import styled from 'styled-components';
import ActionsMenu from '../../ActionsMenu';

const RowActionsMenu = styled(ActionsMenu).attrs(() => ({
  iconSize: 18,
}))`
  &&& {
    margin-right: auto;
  }
`;

export default RowActionsMenu;
